angular
	.module 'App.Component'
	.component 'giftcardIssuer',
	{
		bindings:
			voucherType: '<'
			priceRegions: '<'
		templateUrl: '@component/giftcard-issuer/giftcard-issuer.view.html'
		controller: 'GiftcardIssuerComponent'
		controllerAs: 'giftcardIssuer'
	}

class GiftcardIssuerComponent extends AbstractController
	@register()
	@inject '$filter',
		'$scope'
		'$q'
		'ShopRepository'
		'TenderTypeRepository'
		'VoucherRepository'
		'RenderRepository' # used in UI links
		'ToastService'
		'MessageTerminal'

	initialize: ->
		@loading = false
		@loaderState = 0
		@issuedGiftcards = []
		@tenderTypes = []
		@shops = []
		@selectableShops = []
		@productData = angular.copy @voucherType.product.product_data
		@giftcardInfo =
			voucher_type_id: @voucherType.id
			email: null
			order:
				shop_id: null
				tender_type_id: null
			selection:
				shop: null
				tenderType: null
				productData: _.first(@productData)

		@loadDependencies()

		@$scope.$watch(
			'giftcardIssuer.voucherType.product.product_data',
			=>
				@productData = angular.copy @voucherType.product.product_data

				if @productData.length == 1
					@giftcardInfo.selection.productData = _.first(@productData)

				@loadSelections()
			,
			true
		)

	loadSelections: ->
		for productData in @productData
			priceRegion = _.find(@priceRegions, {id: productData.price_region_id})

			if !priceRegion
				continue

			productData.price_region_name = priceRegion.name

		@setSelectableShops()

	loadDependencies: ->
		@loading = true

		promises = [
			@loadShops()
			@loadTenderTypes()
		]
		@$q
			.all promises
			.finally =>
				promises = null
				@loading = false
				@initialState = angular.copy @giftcardInfo

	loadShops: ->
		@loadEntity(@ShopRepository, 'shops', 'shop')

	loadTenderTypes: ->
		@loadEntity(@TenderTypeRepository, 'tenderTypes', 'tenderType')

	loadEntity: (repository, variableName, selectionField) ->
		query = repository.createQuery()
		query.withoutAnyRelations()

		repository
			.findByQuery query
			.then (response) =>
				@[variableName] = response.data

				if @[variableName].length == 1
					@giftcardInfo.selection[selectionField] = @[variableName][0]

				if variableName == 'shops'
					@setSelectableShops()

	setSelectableShops: ->
		@selectableShops = []

		if !@giftcardInfo.selection.productData?
			return

		for shop in @shops
			if shop.price_region_id == @giftcardInfo.selection.productData.price_region_id
				@selectableShops.push shop

	issueNewGiftcard: ->
		if @giftcardIssueForm.$invalid
			return

		@VoucherRepository
			.findVoucherProvider()
			.then (provider) =>
				info = angular.copy @giftcardInfo
				info.order.shop_id = info.selection.shop.id
				info.order.tender_type_id = info.selection.tenderType?.id
				info.price_region_id = info.selection.productData.price_region_id

				delete info.selection

				@VoucherRepository
					.post provider.id + '/activate', info
					.then (response) =>
						@issuedGiftcards.unshift response.data

						@ToastService.add(
							@$filter('translate')('general.voucher') + ' #' + response.data.id,
							@$filter('translate')('general.voucher'),
							@$filter('translate')('alert.saved'),
							'success'
						)
						@resetForm()
					.catch (response) =>
						@ToastService.showErrors response.data, @$filter('translate')('general.voucher')

	resetForm: ->
		@giftcardInfo = angular.copy @initialState
		@giftcardIssueForm.$setPristine()
		@giftcardIssueForm.$setUntouched()
